import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {VM} from '@hetao/scratch-core';
import WavEncoder from 'wav-encoder';
import {connect} from 'react-redux';

import RecordModalComponent from '../components/record-modal/record-modal.jsx';
import {computeRMS} from '../lib/audio/audio-util.js';
import SharedAudioContext from '../lib/audio/shared-audio-context.js';

import {isMobile} from '../lib/platform';

import {
    closeSoundRecorder
} from '../reducers/modals';

class RecordModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleRecord',
            'handleRecordIpad',
            'handleStopRecording',
            'handleStopRecordingIpad',
            'handleCancelRecordingIpad',
            'handlePlay',
            'handleStopPlaying',
            'handleBack',
            'handleSubmit',
            'handleCancel',
            'handleSetPlayhead',
            'handleSetTrimStart',
            'handleSetTrimEnd',
            'handleOutputAudio'
        ]);

        this.state = {
            samples: null,
            encoding: false,
            levels: null,
            playhead: null,
            playing: false,
            recording: false,
            sampleRate: null,
            trimStart: 0,
            trimEnd: 1
        };
        this.isIpad = isMobile();
        if (this.isIpad) {
            this.handleStopRecording = this.handleStopRecordingIpad;
            this.handleRecord = this.handleRecordIpad;
            window.getNativeOutputAudio_ = this.handleOutputAudio;
            window.getNativeOutputAudio = function (str){
                window.getNativeOutputAudio_ && window.getNativeOutputAudio_(str);
            };
        }


    }
    componentWillUnmount (){
        if (this.isIpad) {
            window.getNativeOutputAudio_ = null;
            // 防止意外情况导致录音一直没被触发停止
            window.webkit && window.webkit.messageHandlers.cancelRecord.postMessage(null);
        }
    }
    handleRecord () {
        this.setState({recording: true});
    }
    handleCancelRecordingIpad (){
        window.webkit && window.webkit.messageHandlers.cancelRecord.postMessage(null);
        this.setState({recording: false});
    }

    handleRecordIpad () {
        window.webkit && window.webkit.messageHandlers.startRecord.postMessage(null);
        this.setState({recording: true});
    }
    handleStopRecording (samples, sampleRate, levels, trimStart, trimEnd) {
        this.setState({samples, sampleRate, levels, trimStart, trimEnd, recording: false});
    }
    handleStopRecordingIpad () {
        window.webkit && window.webkit.messageHandlers.stopRecord.postMessage(null);
        this.setState({recording: false});
    }
    // ipad上调用这个方法后会传入base64的数据 进行转换后使用
    handleOutputAudio (base64data){
        // 先解码转换
        const raw = atob(decodeURIComponent(base64data));
        const rawLen = raw.length;

        // 转换成uinit8Array
        const u8arr = new Uint8Array(new ArrayBuffer(rawLen));
        for (let i = 0; i < rawLen; i++) {
            u8arr[i] = raw.charCodeAt(i);
        }
        // 用audioContext获得float32array数据
        const audioContext = new SharedAudioContext();
        audioContext.decodeAudioData(u8arr.buffer, data => {
            const samples = data.getChannelData(0);
            const levels = [computeRMS(Array.prototype.slice.call(samples, 0))];
            const sampleRate = 44100;
            const trimStart = 0;
            const trimEnd = 1;
            this.setState({samples, sampleRate, levels, trimStart, trimEnd, recording: false});

            // 不能close 会导致所有的地方都不会有声音
            // audioContext.close();
        });
    }
    handlePlay () {
        this.setState({playing: true});
    }
    handleStopPlaying () {
        this.setState({playing: false, playhead: null});
    }
    handleBack () {
        this.setState({playing: false, samples: null});
    }
    handleSetTrimEnd (trimEnd) {
        this.setState({trimEnd});
    }
    handleSetTrimStart (trimStart) {
        this.setState({trimStart});
    }
    handleSetPlayhead (playhead) {
        this.setState({playhead});
    }
    handleSubmit () {
        this.setState({encoding: true}, () => {
            const sampleCount = this.state.samples.length;
            const startIndex = Math.floor(this.state.trimStart * sampleCount);
            const endIndex = Math.floor(this.state.trimEnd * sampleCount);
            const clippedSamples = this.state.samples.slice(startIndex, endIndex);
            WavEncoder.encode({
                sampleRate: this.state.sampleRate,
                channelData: [clippedSamples]
            }).then(wavBuffer => {
                const vmSound = {
                    format: '',
                    dataFormat: 'wav',
                    rate: this.state.sampleRate,
                    sampleCount: clippedSamples.length
                };

                // Load the encoded .wav into the storage cache and get resulting
                // md5 from storage
                const storage = this.props.vm.runtime.storage;
                const md5 = storage.builtinHelper.store(
                    storage.AssetType.Sound,
                    storage.DataFormat.WAV,
                    new Blob([wavBuffer], {
                        type: storage.AssetType.Sound.contentType
                    }),
                ).then(md5 => {
                    // update vmSound object with md5 property
                    vmSound.md5 = `${md5}.${vmSound.dataFormat}`;
                    // The VM will update the sound name to a fresh name
                    // if the following is already taken
                    vmSound.name = 'recording1';

                    this.props.vm.addSound(vmSound).then(() => {
                        this.props.onClose();
                        this.props.onNewSound();
                        // 拓展中的语音积木块“用普通话识别声音”可能需要它更新拓展信息，这个积木块也许也没人用了
                        this.props.vm.runtime.emit('TOOLBOX_EXTENSIONS_NEED_UPDATE');
                    });
                });
            });
        });
    }
    handleCancel () {
        this.props.onClose();
    }
    render () {
        return (
            <RecordModalComponent
                encoding={this.state.encoding}
                levels={this.state.levels}
                playhead={this.state.playhead}
                playing={this.state.playing}
                recording={this.state.recording}
                sampleRate={this.state.sampleRate}
                samples={this.state.samples}
                trimEnd={this.state.trimEnd}
                trimStart={this.state.trimStart}
                onBack={this.handleBack}
                onCancel={this.handleCancel}
                onCancelRecordingIpad={this.handleCancelRecordingIpad}
                onPlay={this.handlePlay}
                onRecord={this.handleRecord}
                onSetPlayhead={this.handleSetPlayhead}
                onSetTrimEnd={this.handleSetTrimEnd}
                onSetTrimStart={this.handleSetTrimStart}
                onStopPlaying={this.handleStopPlaying}
                onStopRecording={this.handleStopRecording}
                onSubmit={this.handleSubmit}
            />
        );
    }
}

RecordModal.propTypes = {
    onClose: PropTypes.func,
    onNewSound: PropTypes.func,
    vm: PropTypes.instanceOf(VM)
};

const mapStateToProps = state => ({
    vm: state.scratchGui.vm
});

const mapDispatchToProps = dispatch => ({
    onClose: () => {
        dispatch(closeSoundRecorder());
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RecordModal);
